module.exports = __webpack_public_path__ + "img/symbol_15.7d5dbef7.png";